<div class="recycle-bin">
  <fieldset class="rms-fieldset filters">
    <legend>Recycle bin</legend>
    <div class="filter-grid">
      <rms-date name="DeletedFrom" label="Deleted From" [(ngModel)]="Filters.DeletedFrom"></rms-date>
      <rms-date name="DeletedThrough" label="Deleted Through" [(ngModel)]="Filters.DeletedThrough"></rms-date>
      <rms-input name="SearchText" label="Search" placeholder="Journal #, reason or who deleted it" [(ngModel)]="Filters.SearchText" (keyup.enter)="load()"></rms-input>
    </div>
    <div class="filter-actions">
      <p class="muted">Only unposted drafts can be deleted. They are kept here permanently and can be restored to Draft after a period and duplicate check. Posted journals are reversed, never deleted.</p>
      <button mat-button class="btn-bg-green" [disabled]="Loading" (click)="load()">Search</button>
    </div>
  </fieldset>

  @if (Loading) {
  <p class="muted" role="status">Loading the recycle bin…</p>
  }

  <rms-table [data]="Rows"
             [columns]="Columns"
             [HeaderButtons]="Buttons"
             [clickableRow]="true"
             (onRowClick)="open($event.row)"
             tableId="ledger-recycle-bin">
  </rms-table>

  <fieldset class="rms-fieldset legacy">
    <legend>Deleted in the previous system</legend>
    <div class="filter-actions">
      <p class="muted">Ledger entries deleted in the Access ledger before RMS. Read-only history; they cannot be restored here.</p>
      <button mat-button class="btn-bg-blue" (click)="toggleLegacy()">{{ ShowLegacy ? 'Hide' : 'Show' }} legacy deletions</button>
    </div>
    @if (ShowLegacy) {
    <rms-table [data]="LegacyRows" [columns]="LegacyColumns" tableId="ledger-legacy-deleted"></rms-table>
    }
  </fieldset>
</div>
